export default __webpack_public_path__ + "static/media/slideshow-icon.9b3eb5ab.svg";